window.MyWindow = {
	defaultName		: "popupWindow",
	small			: 480,
	medium			: 720,
	large 			: 960,
	browserHeight	: document.body.clientHeight,

	
	defaultOpts: {
		modal		: true,
		resizable	: false,
		show		: 'fade',
		hide		: 'fade',
		width		: 480,
		height		: 'auto',
		maxHeight: document.body.clientHeight,
		position	: {
			my : "center top",
			at : "center top+24px",
			of : $(window)
		},
		buttons		: {},
		
		beforeClose	: function(){
			var loaderId = $(this).attr('id');
			if (Utils.exists(loaderId)) {
				MyWindow.awake('alertWindow');
			}
			$(this).empty();
		},

		open : function() {
            $('.preview_nomsie embed').addClass('hidden'); // document
			$('#content_preview embed').addClass('hidden'); // proposal
			
            $('.ui-dialog-buttonpane button').addClass('btn-default');
            // Set automatically the last button as primary action button with check in current window
            // NB: All MyWindows aren't destroy on close
            if ($(this).parent('.ui-dialog').find('.ui-dialog-buttonpane button').length >= 2) {
                $(this).parent('.ui-dialog').find('.ui-dialog-buttonpane button').last().removeClass("btn-default").addClass('btn-primary');
            }

            if ($('.ui-dialog-buttonpane button').hasClass('btn-danger')) {
                $('.ui-dialog-buttonpane button').removeClass("btn-default");
            }

			$(this).css({ 'max-height': MyWindow.browserHeight-200, 'overflow-y': 'auto'});

			$('[datepicker]:not(.hasDatepicker)', this).each(function(){
				$(this).datepicker();
			}) 


        },
		close : function(){
            $('.preview_nomsie embed').removeClass('hidden'); // document
            $('#content_preview embed').removeClass('hidden'); // proposal
			$('input', this).trigger('blur');
			EventBus.on('email:onEmailVerified', Email.removeListenerEmailVerified());
		}
	},
	
	reload: function(id) {
		if($("#"+id)[0] == undefined) {
			$('body').append('<div id="' + id + '"></div>');
		}
	},
	
	/* 3 types match with CSS : confirm, warning, error */
	alert: function(msg, options){

        options = undefined == options ? {} : options;
        var customClass = options.dialogClass == undefined ? '' : options.dialogClass;
		if (options.type) {
            msg = "<div class='windows-alert-"+options.type+"'><span class='windows-alert-icone'></span><span class='windows-alert-msg fs-3'>"+msg+"</span></div>";
			options.dialogClass = 'windows-alert-main-'+options.type;
        }

        if (customClass != ''){
            options.dialogClass += ' ' + customClass
        }

		var presets = {
			dialogClass : 'windows-alert-main',
			width		: 480,
			resizable	: false,
            title		: Loc.g("Message système"),
            dialogClass: "white",
			buttons		: [
				{
					text : Loc.g("Ok"),
					'class': 'btn btn-primary primary-bkg',
					click : function(){
						$(this).dialog("close");
					}
				}
			],
		};

		options = $.extend({}, MyWindow.defaultOpts, presets, options);

		if ($('#alertWindow').length == 0){
			$('body').append("<div id='alertWindow'></div>");
		}

		MyWindow.feed("alertWindow", msg);
		MyWindow.build("alertWindow", options, msg);
	},		
	
	alertMessage: function(msg, place, alertType) {
		MyWindow.alert(msg, {type: alertType});
	},
	
	load: function(file, fileOpts, options, checkAlive, popupId, queue, method, buildFileUrl){
		var id = popupId === undefined ? MyWindow.defaultName : popupId;
		if ($('#'+id).length == 0){
			$('body').append("<div id='"+id+"'></div>");
		}
		
		queue 			= (queue === undefined) ? false : queue;
		method 			= method === undefined ? "POST" : method;
		buildFileUrl 	= buildFileUrl === undefined ? true : buildFileUrl;

		options	= $.extend({}, MyWindow.defaultOpts, options, {maxHeight: MyWindow.browserHeight-24});

		if (options.type) {
			options.dialogClass = 'windows-alert-main-'+options.type;
		}

		if(options.height > $(window).height()) {
			options.height = $(window).height();
		}

		MyWindow.reload(id);
		$("#"+id)[0].innerHTML = MyWindow.getLoader();
		if (undefined !== options.waitMsg) {
            $("#"+id)[0].innerHTML += "<div class='loaderMsg mb-5'>"+options.waitMsg+"</div>";
		}
		MyWindow.build(id, options);
		fileOpts._popup = "1";
		var callback = null;
		if(options.callback){
			callback = options.callback;
			delete options.callback;
		}

		if (buildFileUrl){
			file = MyFacture.buildUrl(file);
		}


		$.ajax({
			url: file,
			method: method,
			data: fileOpts,
			dataType: "html",
			success: function(data) {
				MyWindow.loadCallback(id, data, callback);
			},
			error: function (error) {
				MyWindow.loadCallback(id, error.responseText, callback);
			}
		});

		$('html, body').scrollTop($('.ui-widget-header.ui-corner-all.ui-helper-clearfix').offset().top - 10);
		
		return true;
	},
	
	error : function(){
        MyWindow.load('/error/legacy', {action : 'popup'}, {type : 'error', title : Loc.g('Erreur')}, undefined, undefined, undefined, undefined, false);
	},
	
	addOption : function(option, params, popupId){
		
		var id = popupId === undefined ? MyWindow.defaultName : popupId;
		
		$("#"+id).dialog('option', option, params);
	},
	
	getOption: function(option, popupId){
		var id = popupId === undefined ? MyWindow.defaultName : popupId;
		return $("#"+id).dialog('option',option);
	},
	
	loadCallback: function (id, data, callback) {

		// isString && not html data return
		if (typeof data == 'string' && data.length > 0 && !/^</i.test(data)) {
			data = JSON.parse(data);
		}

		if ( data && data.status !== undefined && data.status == 'logout' ) {
			CheckAlive.performCallback(data);
		} else {
			MyWindow.feed(id, data);
			MyFacture.customForm(undefined, false);
			if (null != callback) {
				Utils.launch(callback(data));
			}
			MyWindow.awake();
		}

	},

	
	feed: function(id, data) {
		MyWindow.reload(id);
		$("#"+id)[0].innerHTML = data !== undefined ? data : Loc.g("Une erreur réseau s'est produite. Veuillez vérifier votre connectivité et ré-essayer.");
	},
	
	build: function(id, options){
		
		var $dialog = $('#' + id);
		$dialog.dialog(options);
		
		if(options.noclose){
			$(".ui-dialog-titlebar-close", MyWindow.getRoot(id)).empty().remove();
		}
		
		MyWindow.enable(id);
		
	},
	
	close: function(id){
		
		if ('_all'==id){
			$('[role=dialog]').each(function () { MyWindow.close($(this).attr('aria-describedby')); });	
			return;
		}

		id = undefined === id ? MyWindow.defaultName : id;
		
		var $window = $('#' + id);

		if ($window.closest('.ui-dialog').length > 0){
			$window.innerHTML = '';
			$window.dialog("close");
		}
	},

	disable: function(id){
		id = undefined===id ? MyWindow.defaultName : id;
		$(":enabled", MyWindow.getRoot(id)).attr("disabled", true);
	},
	
	enable: function(id){
		id = undefined===id ? MyWindow.defaultName : id;
		$(":disabled", MyWindow.getRoot(id)).attr("disabled", false);
	},
	
	wait: function(id, msg){
		
		id = undefined === id ? MyWindow.defaultName : id;
		
		var root = MyWindow.getRoot(id);
		var loaderId = "loader_"+id;
		var wrapperMsg = undefined !== msg ? '<div class="loaderMsg fa-gray">'+msg+'</div>' : '';
		
		root.prepend('<div id="'+loaderId+'" class="loader">'+MyWindow.getLoader()+wrapperMsg+'</div>');
		
		var $loader = $('#' + loaderId);
		$loader.hide();
		
		var rootHeight = root.outerHeight(true)*1;
		$loader.css({
			"width"			: root.outerWidth(true),
			"height"		: rootHeight,
			"padding-top"	: rootHeight/2-(rootHeight/2),
			"z-index"		: root.css("z-index")*1+1
		});
		$loader.fadeTo(0, 0.9);
		return $loader;
	},
	
	awake: function(id){
		id = undefined === id ? MyWindow.defaultName : id;
		var root = MyWindow.getRoot(id);
		var loaderId = "loader_"+id;
		if(Utils.exists(loaderId))
			Utils.remove(loaderId);
	},
	
	getRoot: function(id){
		id = undefined === id ? MyWindow.defaultName : id;
		var root = $("#"+id).parent();
		return root.hasClass("ui-dialog") ? root : $("#"+id);
	},
	
	getLoader: function(){
		
		return '	<div class="loader-logo">'
			+'			<div class="logo-inner">'
			+'				<div class="rect1"></div>'
			+'				<div class="rect2"></div>'
			+'				<div class="rect3"></div>'
			+'				<div class="rect4"></div>'
			+'			</div>'
			+'		</div>'
		;
		
	}
};
